module.exports = vendor_0b1a0f6e96a044be7c1f;